import React from 'react';
import { pains } from '../data/pains';
import { CTAButton } from './CTAButton';
export function PainSection() {
  return <section className="px-4 py-8" data-id="element-113" data-mp="38wlu0t2p6shq">
      <div className="mx-auto max-w-4xl" data-id="element-114" data-mp="38vkhek619xxw">
        <h2 className="text-center font-display text-2xl font-black uppercase leading-tight sm:text-3xl" data-id="element-115" data-mp="2uyx6fdh8x78z">
          Ti ritrovi in una di queste situazioni?
        </h2>
        <div className="mx-auto mt-3 max-w-2xl space-y-1 text-center text-[15px] leading-snug text-graphite sm:text-base" data-id="element-116" data-mp="2l8ce27s60yyi">
          <p data-id="element-117" data-mp="2pzkisqijvw5c">
            Ami il tuo lavoro e vuoi offrire a ogni paziente un intervento organizzato, professionale
            e realmente personalizzato.
          </p>
          <p data-id="element-118" data-mp="2g995wegw2cmb">Ma preparare ogni singola sessione richiede tempo.</p>
          <p data-id="element-119" data-mp="2g9ss47dknn65">
            E quando lavori ogni settimana con pazienti, obiettivi e necessità differenti,
            probabilmente conosci molto bene queste situazioni.
          </p>
        </div>

        <div className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-120" data-mp="2781mt3my1ict">
          {pains.map(pain => <article key={pain.title} className="flex h-full flex-col rounded-xl border border-sage/40 bg-white p-4" data-id="element-121" data-mp="3rlptdtxwm2ka">
              <h3 className="font-display text-base font-extrabold leading-tight sm:text-lg" data-id="element-122" data-mp="5fkj7brcak9z">
                {pain.title}
              </h3>
              {pain.intro && <p className="mt-1.5 text-sm font-semibold text-graphite" data-id="element-123" data-mp="ewrsoz781f8">{pain.intro}</p>}
              <ul className="mt-2 space-y-0.5" data-id="element-124" data-mp="33xg9wyo5xqwb">
                {pain.bullets.map(bullet => <li key={bullet} className="flex gap-2 text-sm leading-snug text-graphite" data-id="element-125" data-mp="33vlprmkpu2ta">
                    <span className="text-terracotta" aria-hidden="true" data-id="element-126" data-mp="3io5ped8nps5z">
                      ✕
                    </span>
                    {bullet}
                  </li>)}
              </ul>
              <div className="mt-auto space-y-0.5 pt-2 text-sm font-semibold leading-snug text-petrol" data-id="element-127" data-mp="2l6ymn9m3nnic">
                {pain.closing.map(line => <p key={line} data-id="element-128" data-mp="p3amn3v8bv6y">{line}</p>)}
              </div>
            </article>)}
        </div>

        <CTAButton className="mx-auto mt-5 max-w-lg" data-id="element-129" data-mp="u0sknz7pkq06" />
      </div>
    </section>;
}